<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> Usuário </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="user.id"
          >{{ user.id }} - {{ user.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="user.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="user.email"
                class=""
                label="Email"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="user.password"
                class="text-field-uppercase"
                label="Senha"
                dense
                outlined
                type="password"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-select
                :items="items"
                v-model="user.type"
                label="Tipo"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="user.status"
                :label="`Status: ${getLabelStatus(user.status)}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="blue darken-3"
                dark
                class="mt-5"
                @click="validate()"
              >
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/UserRequest";
import { TYPES_USER } from "@/api/constants";

export default {
  components: {},
  data: () => ({
    loading: false,
    user: {
      id: "",
      name: "",
      email: "",
      password: "",
      status: 1,
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    items: [],
  }),
  computed: {},
  created() {
    this.items = TYPES_USER;
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getUser(this.$route.params.id);
      }
    },
    async getUser(id) {
      // this.showLoading();
      this.loading = true;
      try {
        this.user = await API.getById(id);
        this.user.password = "*******";
      } catch (error) {
        this.user = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "User" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.user.name = this.user.name.toUpperCase();
        // this.user.status = this.user.status ? 1 : 0;
        if (this.user.password === "*******") {
          this.user.password = "";
        }
        if (this.user.id === "") {
          this.post(this.user);
        } else {
          this.update(this.user.id, this.user);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
